export const state = {
  httpText: '',
  httpColor: '',
  httpIsActive: false,
  isProcessingActive: false
}

export const getters = {
  httpText: state => {
    return state.httpText
  },
  httpColor: state => {
    return state.httpColor
  },
  httpIsActive: state => {
    return state.httpIsActive
  },
  isProcessingActive: state => {
    return state.isProcessingActive
  }
}

export const mutations = {
  SET_HTTP_RESPONSE (state, data) {
    state.httpText = data.text
    state.httpColor = data.color
    state.httpIsActive = true
  },
  RESET_HTTP_RESPONSE (state) {
    state.httpIsActive = false
  },
  SET_PROCESS_ACTIVE (state) {
    state.isProcessingActive = true
  },
  SET_PROCESS_INACTIVE (state) {
    state.isProcessingActive = false
  }
}

export const actions = {
  setHttpResponse ({ commit, dispatch }, payload) {
    commit('SET_HTTP_RESPONSE', payload)

    setTimeout(() => {
      dispatch('resetHttpResponse')
    }, 3000)
  },
  resetHttpResponse ({ commit }) {
    commit('RESET_HTTP_RESPONSE')
  },
  setProcessActive ({ commit }) {
    commit('SET_PROCESS_ACTIVE')
  },
  setProcessInactive ({ commit }) {
    commit('SET_PROCESS_INACTIVE')
  }
}
